export default __webpack_public_path__ + "static/media/Ask-A-Medical-Expert_224x224.7b267fd4.jpg";